module.exports = __webpack_public_path__ + "img/dab_felice.d56929f6.jpg";